module.exports = __webpack_public_path__ + "static/media/phaneroptera_falcata_006_APA.277bbe11.png";